module.exports = __webpack_public_path__ + "img/construction_image_wide.2590333b.jpg";